import { DataWarehouseDataService } from '../../DataService/DataWarehouseDataService';
import { AddOrUpdateTaskPopupManager, CreateCustomerXrefManager, GetAdditionalLineInformationManager, PolishLineDescriptionManager as PolishLineItemDescriptionManager } from '../../Exporters/ManagersExporter';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Select2Helper } from '../../Helpers/Select2Helper';
import { StringHelper } from '../../Helpers/StringHelper';
import { CreateVesselXrefManager } from './CreateVesselXrefManager';
import { AddOrUpdateCommentManager } from './AddOrUpdateCommentManager';
import { OfferProcureShipRfqManager } from './ProcureShip/OfferProcureShipRfqManager';
import { ProcureShipAttachmentManager } from './ProcureShip/ProcureShipAttachmentManager';
import { WritePricesToSheetManager } from './WritePricesToSheetManager';
import { UpdateLineItemArticleCodeManager } from './UpdateLineItemArticleCodeManager';
import { DocAttachmentsPopupManager } from './Popup/DocAttachmentsPopupManager';
import { CreateDepartmentXrefManager } from './CreateDepartmentXrefManager';

export class DataWarehouseDetailManager {
    private docHeaderId : string;
    private docRevisionId : string;
    private source : string;

    private revisionSelectList : JQuery<HTMLElement>;

    private sendToErpInfoModal : ModalHelper; 
    private offerToRobotInfoModal : ModalHelper; 

    private offerProcureShipRfqButton : JQuery<HTMLElement>;
    private offerProcureShipRfqModalHelper : ModalHelper;
    //private offerProcureShipRfqManager : OfferProcureShipRfqManager;

    private declineProcureShipRfqButton : JQuery<HTMLElement>;
    private declineProcureShipRfqModalHelper : ModalHelper;

    private acceptProcureShipPoButton : JQuery<HTMLElement>;
    private acceptProcureShipPoModalHelper : ModalHelper;

    private declineProcureShipPoButton : JQuery<HTMLElement>;
    private declineProcureShipPoModalHelper : ModalHelper;   
    
    private offerShipServRfqButton : JQuery<HTMLElement>;
    private offerShipServRfqModalHelper : ModalHelper;
    //private offerProcureShipRfqManager : OfferProcureShipRfqManager;

    private declineShipServRfqButton : JQuery<HTMLElement>;
    private declineShipServRfqModalHelper : ModalHelper;
    
    private editRequestButton : JQuery<HTMLElement>;
    private editRequestModalHelper : ModalHelper;    
    
    private extraRequestInfoButton : JQuery<HTMLElement>;
    private extraRequestInfoModalHelper : ModalHelper;    

    private vesselXrefButton : JQuery<HTMLElement>;
    private vesselXrefModalHelper : ModalHelper;    
    private createVesselXrefManager : CreateVesselXrefManager;    

    private customerXrefButton : JQuery<HTMLElement>;
    private customerXrefModalHelper : ModalHelper;    
    private createCustomerXrefManager : CreateCustomerXrefManager;    

    private departmentXrefButton : JQuery<HTMLElement>;
    private departmentXrefModalHelper : ModalHelper;    
    private createDepartmentXrefManager : CreateDepartmentXrefManager;    
    
    private extraLineItemInfoModalHelper : ModalHelper;
    private lineItemCommentsModalHelper : ModalHelper;
    private lineCommentsManager : AddOrUpdateCommentManager;

    private requestCommentsButton : JQuery<HTMLElement>;
    private requestCommentsModalHelper : ModalHelper;
    private requestCommentsManager : AddOrUpdateCommentManager;

    private requestAttachmentsButton : JQuery<HTMLElement>;
    private requestAttachmentsModalHelper : ModalHelper;
    private requestAttachmentsManager : ProcureShipAttachmentManager;
    
    private writePricesToSheetButton : JQuery<HTMLElement>;
    private writePricesToSheetModalHelper : ModalHelper;    
    private writePricesToSheetManager : WritePricesToSheetManager;   
    
    private recalculatePricesButton : JQuery<HTMLElement>;
    private recalculatePricesModalHelper : ModalHelper; 

    private tasksForProjectButton : JQuery<HTMLElement>;
    private tasksForProjectModalHelper : ModalHelper; 

    private addTaskForProjectButton : JQuery<HTMLElement>;
    private addTaskModalHelper : ModalHelper;
    private addTaskManager : AddOrUpdateTaskPopupManager;

    private quoteRobotRfqButton : JQuery<HTMLElement>;
    private quoteRobotRfqModalHelper : ModalHelper; 
    
    private changeShipServItemDescriptionButton : JQuery<HTMLElement>;
    private changeShipServItemDescriptionModalHelper : ModalHelper; 
    
    private getShipServAdditionalItemInformationButton : JQuery<HTMLElement>;
    private getShipServAdditionalItemInformationModalHelper : ModalHelper; 
    private getShipServAdditionalItemInformationManager : GetAdditionalLineInformationManager;     
    
    private polishLineItemDescriptionButton : JQuery<HTMLElement>;
    private polishLineItemDescriptionModalHelper : ModalHelper; 
    private polishLineItemDescriptionManager : PolishLineItemDescriptionManager;     
    
    private updateArticleCodeButton : JQuery<HTMLElement>;
    private updateArticleCodeModalHelper : ModalHelper; 
    private updateArticleCodeManager : UpdateLineItemArticleCodeManager; 

    private portalHeaderAdditionalFieldsButton : JQuery<HTMLElement>;
    private portalHeaderAdditionalFieldsModalHelper : ModalHelper; 

    private docAttachmentsManager : DocAttachmentsPopupManager; 

    constructor(private containerElement: JQuery) {
        this.docHeaderId = containerElement.data('doc-header-id');
        this.docRevisionId = containerElement.data('doc-revision-id');
        this.source = containerElement.data('doc-source');
     }

    public initialize() {
        var self = this;

        self.bindElements();

        (<any>window).initializeProcessEnquiry = () => {
            self.bindDetailView();
        }

        self.bindEvents();
        self.bindDetailView();

        $('[data-bs-toggle="tooltip"]').tooltip({ container: 'body', trigger: 'hover' });
    }

    private bindElements() {
        var self = this;

        self.revisionSelectList = $('#revision-select-list');



        this.offerProcureShipRfqModalHelper = new ModalHelper();
        this.offerProcureShipRfqModalHelper.createModal("offer-procureship-rfq-popup", true);

        this.declineProcureShipRfqModalHelper = new ModalHelper();
        this.declineProcureShipRfqModalHelper.createModal("decline-procureship-rfq-popup", true);

        this.acceptProcureShipPoModalHelper = new ModalHelper();
        this.acceptProcureShipPoModalHelper.createModal("accept-procureship-po-popup", true);

        this.declineProcureShipPoModalHelper = new ModalHelper();
        this.declineProcureShipPoModalHelper.createModal("decline-procureship-po-popup", true);        

        this.offerShipServRfqModalHelper = new ModalHelper();
        this.offerShipServRfqModalHelper.createModal("offer-shipserv-rfq-popup", true);

        this.declineShipServRfqModalHelper = new ModalHelper();
        this.declineShipServRfqModalHelper.createModal("decline-shipserv-rfq-popup", true);
        
        this.editRequestModalHelper = new ModalHelper();
        this.editRequestModalHelper.createModal("edit-request-popup", true);        
        
        this.extraRequestInfoModalHelper = new ModalHelper();
        this.extraRequestInfoModalHelper.createModal("extra-request-info-popup", true);        
        
        this.extraLineItemInfoModalHelper = new ModalHelper();
        this.extraLineItemInfoModalHelper.createModal("extra-line-item-info-popup", true);      
        
        this.requestAttachmentsModalHelper = new ModalHelper();
        this.requestAttachmentsModalHelper.createModal("request-attachments-popup", true);
      
        this.lineItemCommentsModalHelper = new ModalHelper();
        this.lineItemCommentsModalHelper.createModal("line-item-comments-popup", true);

        this.requestCommentsModalHelper = new ModalHelper();
        this.requestCommentsModalHelper.createModal("request-comments-popup", true);

        this.vesselXrefModalHelper = new ModalHelper();
        this.vesselXrefModalHelper.createModal("vessel-xref-popup", true);

        this.customerXrefModalHelper = new ModalHelper();
        this.customerXrefModalHelper.createModal("customer-xref-popup", true);
        
        this.departmentXrefModalHelper = new ModalHelper();
        this.departmentXrefModalHelper.createModal("department-xref-popup", true);

        this.writePricesToSheetModalHelper = new ModalHelper();
        this.writePricesToSheetModalHelper.createModal("write-prices-to-sheet-popup", true);

        this.recalculatePricesModalHelper = new ModalHelper();
        this.recalculatePricesModalHelper.createModal("recalculate-prices-popup", true);        
        
        this.changeShipServItemDescriptionModalHelper = new ModalHelper();
        this.changeShipServItemDescriptionModalHelper.createModal("change-shipserv-item-description-popup", true);        
        
        this.getShipServAdditionalItemInformationModalHelper = new ModalHelper();
        this.getShipServAdditionalItemInformationModalHelper.createModal("get-shipserv-additional-item-info-popup", true);        
        
        this.polishLineItemDescriptionModalHelper = new ModalHelper();
        this.polishLineItemDescriptionModalHelper.createModal("polish-line-item-description-popup", true);

        this.sendToErpInfoModal = new ModalHelper();
        this.sendToErpInfoModal.createModal("send-to-erp-info-popup", true);        

        this.offerToRobotInfoModal = new ModalHelper();
        this.offerToRobotInfoModal.createModal("offer-to-robot-info-popup", true);        
        
        this.tasksForProjectModalHelper = new ModalHelper();
        this.tasksForProjectModalHelper.createModal("tasks-for-project-popup", true);

        self.addTaskModalHelper = new ModalHelper();
        self.addTaskModalHelper.createModal("add-or-update-task-popup", true);

        this.updateArticleCodeModalHelper = new ModalHelper();
        this.updateArticleCodeModalHelper.createModal("update-article-code-popup", true);        
        
        this.quoteRobotRfqModalHelper = new ModalHelper();
        this.quoteRobotRfqModalHelper.createModal("quote-portal-request-popup", true);        
        
        this.portalHeaderAdditionalFieldsModalHelper = new ModalHelper();
        this.portalHeaderAdditionalFieldsModalHelper.createModal("portal-request-header-additional-fields-popup", true);
        

        //dwh-document-details-view-container
    } 

    private bindEvents() {
        var self = this;
        self.revisionSelectList.off('change').on('change', () => {
            self.docRevisionId = self.revisionSelectList.val().toString();

            self.containerElement.load(`?docHeaderId=${self.docHeaderId}&docRevisionId=${self.docRevisionId}&handler=DetailPageForHeaderAndRevision`, () => {
                self.bindDetailView();
            })
        })

        self.containerElement.find('form[data-send-to-erp-form]').each((index, element) => {
            var sendToErpForm = $(element);

            var sendToErpButton = sendToErpForm.find('button[data-send-to-erp-button]');
            var sendToErpButtonParent = sendToErpButton.parent();

            var clickElement = sendToErpButton;
            if(sendToErpButtonParent.is('li')) {
                clickElement = sendToErpButtonParent;
            }

            clickElement.off('click').on('click', () => {
                clickElement.prop('disabled', true);

                DataWarehouseDataService.canSendToRevisionToErp(self.docHeaderId, self.docRevisionId, (result) => {
                    if(result) {
                        sendToErpForm.trigger('submit');
                    }
                    else {
                        self.sendToErpInfoModal.load(`?docRevisionId=${self.docRevisionId}&handler=CantSendToErpInfo`);
                        clickElement.prop('disabled', false);
                    }
                })
            })
        })

    }

    private bindDetailView() {
        var self = this;

        //#region ProcureShip
        self.offerProcureShipRfqButton = self.containerElement.find('#offer-procureship-rfq-button');
        self.offerProcureShipRfqButton.off('click').on('click', () => {
            self.offerProcureShipRfqModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=OfferProcureShipRfq`, undefined, () => {
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });

        // (<any>window).initializeOfferProcureShipRfq = () => {
        //     self.offerProcureShipRfqManager.initialize();
        // }

        self.declineProcureShipRfqButton = self.containerElement.find('#decline-procureship-rfq-button');
        self.declineProcureShipRfqButton.off('click').on('click', () => {
            self.declineProcureShipRfqModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=DeclineProcureShipRfq`, undefined, () => {
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });

        self.acceptProcureShipPoButton = self.containerElement.find('#accept-procureship-po-button');
        self.acceptProcureShipPoButton.off('click').on('click', () => {
            self.acceptProcureShipPoModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=AcceptProcureShipPo`, undefined, () => {
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });

        self.declineProcureShipPoButton = self.containerElement.find('#decline-procureship-po-button');
        self.declineProcureShipPoButton.off('click').on('click', () => {
            self.declineProcureShipPoModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=DeclineProcureShipPo`, undefined, () => {
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });        
        //#endregion
        
        //#region ShipServ

        self.customerXrefButton = self.containerElement.find('#customer-xref-button');
        self.customerXrefButton.off('click').on('click', () => {
            self.customerXrefModalHelper.load(`/Company/DataWarehouse/Index?docHeaderId=${self.docHeaderId}&invokeLocation=DwhDetail&handler=CreateCustomerXref`, undefined, () => {
                if(self.createCustomerXrefManager == undefined) {
                    self.createCustomerXrefManager = new CreateCustomerXrefManager(self.customerXrefModalHelper.getModalContainer());
                }

                self.createCustomerXrefManager.initialize();
            }, 
            undefined);
        });

        self.vesselXrefButton = self.containerElement.find('#vessel-xref-button');
        self.vesselXrefButton.off('click').on('click', () => {
            self.vesselXrefModalHelper.load(`/Company/DataWarehouse/Index?docHeaderId=${self.docHeaderId}&invokeLocation=DwhDetail&handler=CreateVesselXref`, undefined, () => {
                if(self.createVesselXrefManager == undefined) {
                    self.createVesselXrefManager = new CreateVesselXrefManager(self.vesselXrefModalHelper.getModalContainer());
                }

                self.createVesselXrefManager.initialize();
            }, 
            undefined);
        });

        self.departmentXrefButton = self.containerElement.find('#department-xref-button');
        self.departmentXrefButton.off('click').on('click', () => {
            self.departmentXrefModalHelper.load(`/Company/DataWarehouse/Index?docHeaderId=${self.docHeaderId}&invokeLocation=DwhDetail&handler=CreateDepartmentXref`, undefined, () => {
                if(self.createDepartmentXrefManager == undefined) {
                    self.createDepartmentXrefManager = new CreateDepartmentXrefManager(self.departmentXrefModalHelper.getModalContainer());
                }

                self.createDepartmentXrefManager.initialize();
            }, 
            undefined);
        });

        self.containerElement.find('i[data-extra-info-for-line-id]').each((index, element) => {
            var extraInfoButton = $(element);
            var lineId = extraInfoButton.data('extra-info-for-line-id');

            extraInfoButton.off('click').on('click', () => {
                self.extraLineItemInfoModalHelper.load(`?lineItemId=${lineId}&docRevisionId=${self.docRevisionId}&handler=ExtraLineItemInfo`, undefined, () => {

                }, undefined);
            });
        })

        
        self.requestAttachmentsButton = self.containerElement.find('#request-attachments-button');
        self.requestAttachmentsButton.off('click').on('click', () => {
            self.requestAttachmentsModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=RequestAttachments`, undefined, () => {
                var popupModalContainer = self.requestAttachmentsModalHelper.getModalContainer();
                var isDocAttachmentsPopup = popupModalContainer.find('#doc-attachments-popup').length > 0;

                if(isDocAttachmentsPopup) {
                    if(self.docAttachmentsManager == undefined) {
                        self.docAttachmentsManager = new DocAttachmentsPopupManager(self.requestAttachmentsModalHelper.getModalContainer());
                    }

                    self.docAttachmentsManager.initialize(self.docHeaderId, self.docRevisionId);
                }
                else {
                    if(self.requestAttachmentsManager == undefined) {
                        self.requestAttachmentsManager = new ProcureShipAttachmentManager(self.requestAttachmentsModalHelper.getModalContainer());
                    }

                    self.requestAttachmentsManager.initialize(self.docHeaderId, self.docRevisionId);
                }


            }, 
            undefined);
        });        
        
        self.requestCommentsButton = self.containerElement.find('#request-comments-button');
        self.requestCommentsButton.off('click').on('click', () => {
            self.requestCommentsModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=RequestComments`, undefined, () => {
                if(self.requestCommentsManager == undefined) {
                    self.requestCommentsManager = new AddOrUpdateCommentManager(self.requestCommentsModalHelper.getModalContainer());
                }

                self.requestCommentsManager.initialize(self.docHeaderId, self.docRevisionId);
            }, 
            undefined);
        });

        //
        self.containerElement.find('[data-attchments-for-line-id]').each((index, element) => {
            var attchmentsButton = $(element);
            var lineId = attchmentsButton.data('attchments-for-line-id');

            attchmentsButton.off('click').on('click', () => {
                self.requestAttachmentsModalHelper.load(`?lineItemId=${lineId}&docRevisionId=${self.docRevisionId}&handler=LineAttachments`, undefined, () => {
                    // if(self.lineCommentsManager == undefined) {
                    //     //TODO: Switch between ShipServ and PS
                    //     self.lineCommentsManager = new AddOrUpdateCommentManager(self.lineItemCommentsModalHelper.getModalContainer());
                    // }
    
                    // self.lineCommentsManager.initialize(self.docHeaderId, self.docRevisionId, lineId);
                }, undefined);
            });
        });


        self.containerElement.find('i[data-comments-for-line-id]').each((index, element) => {
            var commentsButton = $(element);
            var lineId = commentsButton.data('comments-for-line-id');

            commentsButton.off('click').on('click', () => {
                self.lineItemCommentsModalHelper.load(`?lineItemId=${lineId}&docRevisionId=${self.docRevisionId}&handler=LineComments`, undefined, () => {
                    if(self.lineCommentsManager == undefined) {
                        //TODO: Switch between ShipServ and PS
                        self.lineCommentsManager = new AddOrUpdateCommentManager(self.lineItemCommentsModalHelper.getModalContainer());
                    }
    
                    self.lineCommentsManager.initialize(self.docHeaderId, self.docRevisionId, lineId);
                }, undefined);
            });
        });



        self.offerShipServRfqButton = self.containerElement.find('#offer-shipserv-rfq-button');
        self.offerShipServRfqButton.off('click').on('click', () => {
            self.offerShipServRfqModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=OfferShipServRfq`, undefined, () => {
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });

        // (<any>window).initializeOfferProcureShipRfq = () => {
        //     self.offerProcureShipRfqManager.initialize();
        // }

        self.declineShipServRfqButton = self.containerElement.find('#decline-shipserv-rfq-button');
        self.declineShipServRfqButton.off('click').on('click', () => {
            self.declineShipServRfqModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=DeclineShipServRfq`, undefined, () => {
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });

        //#endregion


        function bindEditRequest() {
            StringHelper.bindNumberStringInputs();

            self.editRequestModalHelper.getModalContainer().find('select.select2').each((index, element) => {
                var selectElement = $(element);
                Select2Helper.BindSelect2Input(selectElement);
            });
        }
        self.editRequestButton = self.containerElement.find('#edit-request-button');
        self.editRequestButton.off('click').on('click', () => {
            self.editRequestModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=EditRequest`, undefined, () => {
                bindEditRequest();
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });  
        
        (<any>window).initializeEditRequest = () => {
            bindEditRequest();
        }
        
        self.extraRequestInfoButton = self.containerElement.find('#extra-request-info-button');
        self.extraRequestInfoButton.off('click').on('click', () => {
            self.extraRequestInfoModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=ExtraRequestInfo`, undefined, () => {
                
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });

        self.recalculatePricesButton = self.containerElement.find('#recalculate-prices-button');
        self.recalculatePricesButton.off('click').on('click', () => {
            self.recalculatePricesModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=RecalculatePrices`, undefined, () => {
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });        
        
        self.changeShipServItemDescriptionButton = self.containerElement.find('#change-shipserv-item-description-button');
        self.changeShipServItemDescriptionButton.off('click').on('click', () => {
            self.changeShipServItemDescriptionModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=ChangeShipServItemDescription`, undefined, () => {
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });

        self.getShipServAdditionalItemInformationButton = self.containerElement.find('#get-shipserv-additional-item-info-button');
        self.getShipServAdditionalItemInformationButton.off('click').on('click', () => {
            self.getShipServAdditionalItemInformationModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=ShipServAdditionalItemInfo`, undefined, () => {
                if(self.getShipServAdditionalItemInformationManager == undefined) {
                    self.getShipServAdditionalItemInformationManager = new GetAdditionalLineInformationManager(self.getShipServAdditionalItemInformationModalHelper.getModalContainer());
                }

                self.getShipServAdditionalItemInformationManager.initialize();
            }, 
            undefined);
        });
        
        (<any>window).initializeGetShipServAdditionalItemInformation = () => {
            if(self.getShipServAdditionalItemInformationModalHelper.getModalContainer().find('.alert-danger').length != 0) {
                self.getShipServAdditionalItemInformationManager.initialize();
            }
            
        }        
        
        
        self.polishLineItemDescriptionButton = self.containerElement.find('#polish-line-item-description-button');
        self.polishLineItemDescriptionButton.off('click').on('click', () => {
            self.polishLineItemDescriptionModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=PolishLineItemDescription`, undefined, () => {
                if(self.polishLineItemDescriptionManager == undefined) {
                    self.polishLineItemDescriptionManager = new PolishLineItemDescriptionManager(self.polishLineItemDescriptionModalHelper.getModalContainer());
                }

                self.polishLineItemDescriptionManager.initialize();
            }, 
            undefined);
        });
        
        (<any>window).initializePolishLineItemDescription = () => {
            if(self.polishLineItemDescriptionModalHelper.getModalContainer().find('.alert-danger').length != 0) {
                self.polishLineItemDescriptionManager.initialize();
            }
            
        }

        self.writePricesToSheetButton = self.containerElement.find('#write-prices-to-sheet-button');
        self.writePricesToSheetButton.off('click').on('click', () => {
            self.writePricesToSheetModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=WritePricesToSheet`, undefined, () => {
                if(self.writePricesToSheetManager == undefined) {
                    self.writePricesToSheetManager = new WritePricesToSheetManager(self.writePricesToSheetModalHelper.getModalContainer());
                }

                self.writePricesToSheetManager.initialize();
            }, 
            undefined);
        });

        
        self.tasksForProjectButton = self.containerElement.find('#tasks-for-project-button');
        self.tasksForProjectButton.off('click').on('click', () => {
            self.tasksForProjectModalHelper.load(`/Company/Workload/Task?taskLinkType=Project&taskLinkId=${self.docHeaderId}&handler=TaskOverviewForLink`, undefined, () => {
                // if(self.offerProcureShipRfqManager == undefined) {
                //     self.offerProcureShipRfqManager = new OfferProcureShipRfqManager(self.offerProcureShipRfqModalHelper.getModalContainer());
                // }

                // self.offerProcureShipRfqManager.initialize();
            }, 
            undefined);
        });

        self.addTaskForProjectButton = self.containerElement.find('#add-project-task-button');
        self.addTaskForProjectButton.off('click').on('click', () => {

            self.addTaskModalHelper.load(`/Company/Workload/Task?docHeaderId=${self.docHeaderId}&handler=AddOrUpdateTask`, undefined, () => {
                if(self.addTaskManager == undefined) {
                    self.addTaskManager = new AddOrUpdateTaskPopupManager(self.addTaskModalHelper.getModalContainer());
                }

                self.addTaskManager.initialize();
            });
        });

        (<any>window).initializeAddOrUpdateTask = () => {
            if(self.addTaskModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                location.reload();
            }
            else {
                self.addTaskManager.initialize();
            }
        }        
        
        self.updateArticleCodeButton = self.containerElement.find('#update-article-code-button');
        self.updateArticleCodeButton.off('click').on('click', () => {

            self.updateArticleCodeModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=UpdateArticleCode`, undefined, () => {
                if(self.updateArticleCodeManager == undefined) {
                    self.updateArticleCodeManager = new UpdateLineItemArticleCodeManager(self.updateArticleCodeModalHelper.getModalContainer());
                }

                self.updateArticleCodeManager.initialize();
            }, () => {
                location.reload();
            });
        });

        // (<any>window).initializeUpdateArticleCode = () => {
        //     if(self.updateArticleCodeModalHelper.getModalContainer().find('.alert-danger').length == 0) {
        //         //TODO: Als het een line is mogelijk direct inline editten ipv refresh
        //         location.reload();
        //     }
        //     else {
        //         self.updateArticleCodeManager.initialize();
        //     }
        // }

        self.quoteRobotRfqButton = self.containerElement.find('#offer-robot-rfq-button');
        self.quoteRobotRfqButton.off('click').on('click', () => {
            self.quoteRobotRfqButton.prop('disabled', true);

            DataWarehouseDataService.canOfferRevisionToRobot(self.docHeaderId, self.docRevisionId, (result) => {
                if(result) {
                    self.quoteRobotRfqModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=QuotePortalRequest`, undefined, () => {
                        // if(self.addTaskManager == undefined) {
                        //     self.addTaskManager = new AddOrUpdateTaskPopupManager(self.addTaskModalHelper.getModalContainer());
                        // }

                        // self.addTaskManager.initialize();
                    });
                }
                else {
                    self.sendToErpInfoModal.load(`?docRevisionId=${self.docRevisionId}&handler=CantOfferToRobotInfo`);
                    self.quoteRobotRfqButton.prop('disabled', false);
                }
            })




        });

        
        self.portalHeaderAdditionalFieldsButton = self.containerElement.find('#portal-request-header-additional-fields-button');
        self.portalHeaderAdditionalFieldsButton.off('click').on('click', () => {

            self.portalHeaderAdditionalFieldsModalHelper.load(`?docRevisionId=${self.docRevisionId}&handler=PortalRequestHeaderAdditionalFields`, undefined, () => {
                // if(self.addTaskManager == undefined) {
                //     self.addTaskManager = new AddOrUpdateTaskPopupManager(self.addTaskModalHelper.getModalContainer());
                // }

                // self.addTaskManager.initialize();
            });
        });

        (<any>window).initializeQuotePortalRequest = () => {
            if(self.quoteRobotRfqModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                location.reload();
            }
            else {
                //self.addTaskManager.initialize();
            }
        }      

        $('.article-search-method-popover').each((index, element) => {
            var searchMethodPopover = $(element);

            self.searchMethodPopoverInitializer(searchMethodPopover);
        });

        $('.impa-popover').each((index, element) => {
            var impaPopover = $(element);

            self.impaPopoverInitializer(impaPopover);
        });

        $('body').on('click', function (e) {
            if ($(e.target).data('toggle') !== 'popover'
                && $(e.target).parents('.popover').length === 0) { 
                $('[data-bs-toggle="popover"]').popover('hide');
            }
        });

        document.addEventListener('scroll', function (event) {
            $('[data-bs-toggle="popover"]').popover('hide');
        }, true /*Capture event*/);
    }


    private impaPopoverInitializer(impaPopover : JQuery<HTMLElement>) {
        var self = this;
        var lineId = impaPopover.closest('tr').data('line-id');

        var impaCode = impaPopover.data('impa-code');
        var impaDescription = impaPopover.data('impa-description');
        var impaPercentageClass = impaPopover.data('impa-percentage-class');
        var impaPercentage = impaPopover.data('impa-percentage');

        var hasSuggestionsAvailable: boolean = impaPopover.data('has-suggestions-available') == 'True';
        var mayEditOrRemoveImpa : boolean = impaPopover.data('may-edit-or-remove-impa') == 'True';
        var articleMatchingEnabled : boolean = impaPopover.data('article-matching-enabled');

        var isSearchMethodImpa : boolean = impaPopover.data('is-search-method-impa') == 'True';
        var searchMethod = impaPopover.data('search-method');
        var searchArticleCode = impaPopover.data('search-article-code');
        var searchArticleDescription = impaPopover.data('search-article-description');

        if(!isSearchMethodImpa && searchMethod.length > 0 && searchArticleDescription.length > 0) {
            impaDescription = searchArticleDescription;
        }

        var title = `<div class="impa-heading-container" id="impa-heading-container">`;

        if(isSearchMethodImpa == false && searchMethod?.toString().length > 0 && searchArticleCode?.toString().length > 0) {

            title += `<div class="impa-popup-code-text"><label>${searchArticleCode}</label></div>
            <div>
                <label>${searchMethod}</label>
            </div>`;
        }
        else {
            title += `<div class="impa-popup-code-text"><label>${impaCode}</label></div>
                <div class="impa-popup-percentage-container ${impaPercentageClass}">
                    <label>Match ${impaPercentage}%</label>
                </div>`;
        }
            
        title += '</div>';

        var impaActionOptions = `<div class="d-flex">`;
        if(mayEditOrRemoveImpa) {
            impaActionOptions += 
            `<button class="btn btn-xs ${hasSuggestionsAvailable ? "remove-or-edit-button" : ""} w-100 btn-danger text-center me-1" type="button" data-action="remove-impa-button">
                Remove impa
            </button>`;

            if(hasSuggestionsAvailable && articleMatchingEnabled) {
                impaActionOptions += 
                    `<button class="btn btn-xs remove-or-edit-button w-100 btn-primary text-center" type="button" data-action="choose-article-no-from-suggestion-button">
                        Choose from suggestion
                    </button>`;
            }
        }

        impaActionOptions += '</div>'

        impaPopover.popover({
            html: true,
            trigger: "click",
            placement: 'bottom',
            container: '#dwh-document-details-view-container',
            customClass: "impa-popover-container",
            fallbackPlacements: ['top', 'bottom'],
            title: title,
            sanitize: false,
            content: 
            `<div id="impa-info-container">
                <p class="mb-1">${impaDescription}</p>
                ${impaActionOptions}
            </div>
            <div class="d-none" id="confirm-remove-container" >
                <p>Are you sure you want to remove this IMPA? This action cannot be reverted.</p>
                <div class="d-flex justify-content-between mt-1">
                    <button class="btn btn-xs btn-secondary text-center" type="button" data-action="cancel-remove-impa-button">
                        Cancel
                    </button>
                    <button class="btn btn-xs btn-primary text-center" type="button" data-action="confirm-remove-impa-button">
                        Confirm
                    </button>
                </div>
            </div>`,
        })
        .on("inserted.bs.popover", () => {
            var popoverId = impaPopover.attr('aria-describedby');
            var popover = $(`#${popoverId}`);

            var removeButton = popover.find('button[data-action="remove-impa-button"]');
            var cancelButton = popover.find('button[data-action="cancel-remove-impa-button"]');
            var confirmButton = popover.find('button[data-action="confirm-remove-impa-button"]');

            var removeInfoContainer = popover.find('#confirm-remove-container');
            var impaInfoContainer = popover.find('#impa-info-container');
            removeButton.off('click').on('click', () => {
                impaInfoContainer.addClass('d-none');
                removeInfoContainer.removeClass('d-none');

                removeButton.prop('disabled', true)
            })

            cancelButton.off('click').on('click', () => {
                removeInfoContainer.addClass('d-none');
                impaInfoContainer.removeClass('d-none');

                removeButton.prop('disabled', false)
            })

            confirmButton.off('click').on('click', () => {
                impaPopover.popover('hide');
                DataWarehouseDataService.deleteDocDetailImpaCode(lineId, (result) => {
                    if(result) {
                        impaPopover.closest('tr').find('.article-search-method-popover').remove();
                        impaPopover.remove();
                    }
                })
            })

            var chooseArticleNoFromSuggestionButton = popover.find('button[data-action="choose-article-no-from-suggestion-button"]');
            chooseArticleNoFromSuggestionButton.off('click').on('click', () => {
                impaPopover.popover('hide');
                chooseArticleNoFromSuggestionButton.prop('disabled', true);
                self.updateArticleCodeModalHelper.load(`?docRevisionId=${self.docRevisionId}&docDetailId=${lineId}&handler=UpdateArticleCode`, undefined, () => {
                    chooseArticleNoFromSuggestionButton.prop('disabled', false);
                    if(self.updateArticleCodeManager == undefined) {
                        self.updateArticleCodeManager = new UpdateLineItemArticleCodeManager(self.updateArticleCodeModalHelper.getModalContainer());
                    }

                    self.updateArticleCodeManager.initialize();
                });
            })
        });
    }
    
    
    private searchMethodPopoverInitializer(searchMethodPopover : JQuery<HTMLElement>) {
        var highlightedOption = searchMethodPopover.data('search-method-highlighted-option');
        var articleMatchingEnabled : boolean = searchMethodPopover.data('article-matching-enabled');

        searchMethodPopover.popover({
            html: true,
            trigger: "click",
            placement: 'bottom',
            container: '#dwh-document-details-view-container',
            customClass: "impa-popover-container",
            fallbackPlacements: ['top', 'bottom'],
            title: `<div class="impa-heading-container" id="impa-heading-container">
                <div class="impa-popup-code-text">Article search methods</div>
            </div>`,
            sanitize: false,
            content: 
            `<div>
                <p class="mb-0 search-method-info ${highlightedOption == 1 ? "search-method-info-highlighted" : ""}"><label style="width:15px"><b>A</b>:</label> IMPA from ArticleCode</p>
                <p class="mb-0 search-method-info ${highlightedOption == 2 ? "search-method-info-highlighted" : ""}"><label style="width:15px"><b>B</b>:</label> IMPA in description</p>
                <p class="mb-0 search-method-info ${highlightedOption == 3 ? "search-method-info-highlighted" : ""}"><label style="width:15px"><b>C</b>:</label> Description cross-reference</p>
                <p class="mb-0 search-method-info ${highlightedOption == 4 ? "search-method-info-highlighted" : ""}"><label style="width:15px"><b>D</b>:</label> Exact description match</p>
                <p class="mb-0 search-method-info ${highlightedOption == 5 ? "search-method-info-highlighted" : ""}"><label style="width:15px"><b>E</b>:</label> Order history customer</p>
                <p class="mb-0 search-method-info ${highlightedOption == 6 ? "search-method-info-highlighted" : ""} ${articleMatchingEnabled ? "" : "d-none"}"><label style="width:15px"><b>F</b>:</label> Fuzzy lookup</p>
            </div>`
        });
    }


}